export const PAGINATION_VISIBLE_NUMBERS = 5
export const PAGINATION_ITEMS_PER_PAGE = 8
export const RECORD_NOT_SAVED_WARNING = 'Вы вносили изменения в запись. Уверены, что хотите закончить редактирование без сохранения?'